import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
} from '@angular/core';
import { NgClass } from '@angular/common';
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import {
  MultiUploadOrientation,
  UploadMultipleFilesInterface,
} from '../../types';
import { FileToUrlPipe } from '@core-utils';
import { KeeniconComponent } from '../../partials';

@Component({
  selector: 'ui-form-multi-upload-image',
  imports: [CdkDropList, CdkDrag, NgClass, FileToUrlPipe, KeeniconComponent],
  templateUrl: './form-multi-upload-image.component.html',
  styleUrl: './form-multi-upload-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class FormMultiUploadImageComponent {
  protected readonly MultiUploadOrientation = MultiUploadOrientation;
  dataCy = input<string>('');
  files = model<UploadMultipleFilesInterface[]>([]);
  maxFiles = input<number>(5);
  description = input<string>('');
  orientation = input<MultiUploadOrientation>(
    MultiUploadOrientation.horizontal,
  );
  filesChanged = output<UploadMultipleFilesInterface[]>();

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files) {
      const imageFiles = Array.from(files).filter((file) =>
        file.type.startsWith('image/'),
      );
      const currentFiles = this.files();
      const newFiles = imageFiles.map((file, index) => ({
        file,
        order: currentFiles.length + index,
      }));
      const combinedFiles = [...currentFiles, ...newFiles];
      const resultFiles =
        combinedFiles.length > this.maxFiles()
          ? combinedFiles.slice(-this.maxFiles())
          : combinedFiles;

      resultFiles.forEach((file, index) => {
        file.order = index;
      });

      this.files.set(resultFiles);
      this.filesChanged.emit(resultFiles);
    }
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const filesArray = Array.from(input.files);
      const currentFiles = this.files();
      const newFiles = filesArray.map((file, index) => ({
        file,
        order: currentFiles.length + index,
      }));
      const combinedFiles = [...currentFiles, ...newFiles];
      const resultFiles =
        combinedFiles.length > this.maxFiles()
          ? combinedFiles.slice(-this.maxFiles())
          : combinedFiles;

      resultFiles.forEach((file, index) => {
        file.order = index;
      });

      this.files.set(resultFiles);
      this.filesChanged.emit(resultFiles);
    }
  }

  drop(event: CdkDragDrop<UploadMultipleFilesInterface[]>) {
    const files = [...this.files()]; // создаем копию массива
    moveItemInArray(files, event.previousIndex, event.currentIndex);

    files.forEach((file, index) => {
      file.order = index;
    });

    this.files.set(files);
    this.filesChanged.emit(files);
  }

  removeImage(index: number) {
    const files = this.files();
    files.splice(index, 1);
    this.files.set(files);
    this.filesChanged.emit(files);
  }
}
